const DEFAULT_UNIT_LABEL = 'Splošno';

/**
 * Resolve display label for content unit/category (general vs organizational unit).
 */
export function resolveContentUnitLabel(item, unitNames = {}) {
  if (!item) {
    return DEFAULT_UNIT_LABEL;
  }

  if (item.unit === 'general') {
    return DEFAULT_UNIT_LABEL;
  }

  return item.unitName || unitNames[item.unit] || DEFAULT_UNIT_LABEL;
}
